import { render } from "./EligiblityCriteriaView.vue?vue&type=template&id=72ba7034"
import script from "./EligiblityCriteriaView.vue?vue&type=script&lang=js"
export * from "./EligiblityCriteriaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__